import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import apiClient from 'apiClient';

class PusherService extends Component {
  componentDidMount() {
    this.createPusherClient();
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
      this.pusher.unsubscribe(this.channelIdForCurrentUser());
      this.pusher.disconnect();
    }
  }

  createPusherClient = () => {
    Pusher.logToConsole = process.env.NODE_ENV === 'development';

    this.pusher = new Pusher(process.env.PUSHER_APP_KEY, {
      cluster: process.env.PUSHER_CLUSTER,
      encrypted: true,
      authorizer: (channel) => ({
        authorize: (socket_id, callback) => {
          apiClient
            .post('/pusher/auth', {
              channel_name: channel.name,
              socket_id,
            })
            .then((response) => {
              callback(false, response);
            })
            .catch((error) => {
              callback(true, error);
            });
        },
      }),
    });

    this.subscribeToChannel();
  };

  subscribeToChannel = () => {
    const channelId = this.channelIdForCurrentUser();
    this.channel = this.pusher.subscribe(channelId);
    this.channel.bind('new-recordable-activity', this.activityReceived);
    this.channel.bind('document', this.activityReceived);
  };

  activityReceived = (activityItem) => {
    if (this.props.onActivityReceived) {
      this.props.onActivityReceived(activityItem);
    }
  };

  channelIdForCurrentUser = () => {
    return `private-${this.props.user.company_id}`;
  };

  render() {
    return null;
  }
}

PusherService.propTypes = {
  user: PropTypes.any,
  onActivityReceived: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(PusherService);
